<mat-card class="bando-card p--lg-48 p--24 m--0">
    <mat-card-header class="mb--0 p--0">
        <span [class]="'status-badge ' + getStatusClass(bando.status)">
            {{ getStatusLabel(bando.status) }}
          </span> 
        <mat-card-title class="mb--0">
            <div class="bando-title" [innerHTML]="bando.section_program"></div>
        </mat-card-title>
        <mat-card-subtitle class="mb--0 text-primary">
            <small class="text-primary">{{ formatDeadlineMessage(bando.deadline_days_left, bando.deadline_label) }}</small>
        </mat-card-subtitle>
       
    </mat-card-header>
    <mat-card-content class="px--0 py--8">
        <div class="bando-description" [innerHTML]="bando.title"></div>
    </mat-card-content>
    <mat-card-actions class="px--0">
        <button mat-button color="primary" class="p--0" (click)="goToBando()">Scopri di pi&ugrave; <span class="di di-arrow-right"></span></button>
    </mat-card-actions>
</mat-card>
